export enum GivenTypeEnum {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
  Timestamp = 'Timestamp'
  // TimestampTz = 'TimestampTz'
}
